import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import Title from "../../../../components/elements/Title";
import Profits from "./Profits";
import ProfitsChart from "./ProfitsChart";
import MyProfits from "./MyProfits";


function ProfitsPage({manage}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={manage ? t('manageProfits') : t('myProfits')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{manage ? t('manageProfits') : t('myProfits')}</Title>

                   {/* {
                        manage ?
                            <ProfitsChart manage/>
                            :
                            <ProfitsChart/>
                    }*/}
                </Grid>
                <Grid item size={12}>
                    {
                        manage ?
                            <Profits/>
                            :
                            <MyProfits/>
                    }

                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(ProfitsPage);
